import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({

  reservation : {//Object utilisé lors de la création de réservation
    details : [],
    customer : null,
    salesRepId : null,
    selectedContacts : [],
  },

  loadingCustomers : false,
  customers : [],
  loadingDetailItems : false,
  editorLoading : false
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
